import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { GroupOfAdminsCreateSchema } from '@modules/groups-of-admins/submodules/create/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { GROUPS_OF_ADMINS_LIST_QUERY_KEY, GROUPS_OF_ADMINS_PERMISSIONS } from '@modules/groups-of-admins/constants';
import {
  GROUPS_OF_ADMINS_CREATE_MUTATION_API_URL,
  GROUPS_OF_ADMINS_CREATE_MUTATION_KEY,
  TRANSLATION_GROUPS_OF_ADMINS_CREATE,
} from '@modules/groups-of-admins/submodules/create/constants';
import { useI18n } from '@modules/i18n/composables';
import { useToastStore } from '@modules/toast/store';

export default function useGroupsOfAdminsCreateMutation(): IContextMutationResult<
  void,
  Error,
  GroupOfAdminsCreateSchema
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();
  const { getTranslation } = useI18n();

  return useContextMutation<void, Error, GroupOfAdminsCreateSchema>({
    mutationKey: [GROUPS_OF_ADMINS_CREATE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      GROUPS_OF_ADMINS_CREATE_MUTATION_API_URL,
      { admin_group: payload },
      { permission: GROUPS_OF_ADMINS_PERMISSIONS.EDIT },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [GROUPS_OF_ADMINS_LIST_QUERY_KEY] });
      displayPresetToast('created', getTranslation(TRANSLATION_GROUPS_OF_ADMINS_CREATE, 'GROUP_CREATED').value);
    },
  });
}
